/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyManat = createReactComponent("currency-manat", "IconCurrencyManat", [
  ["path", { d: "M7 19v-7a5 5 0 1 1 10 0v7", key: "svg-0" }],
  ["path", { d: "M12 5v14", key: "svg-1" }]
]);

export { IconCurrencyManat as default };
//# sourceMappingURL=IconCurrencyManat.js.map
